<template>
  <div class="appPublish">
    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="楼盘名" align="center">
        <template slot-scope="scope">
          {{ scope.row.houseName }}
        </template>
      </el-table-column>
      <el-table-column label="客户名" align="center">
        <template slot-scope="scope">
          {{ scope.row.customerName }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="客户电话" align="center">
        <template slot-scope="scope">
          {{ scope.row.customerMobile }}
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        label="身份证号码"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.customerLastSixId }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="销售员" align="center">
        <template slot-scope="scope">
          {{ scope.row.salesPersonName || '--' }}
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              size="small"
              @click="handleExamineBtn(scope.row)"
              >审批</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改表单对话框 -->
    <editForm ref="editForm" />
  </div>
</template>

<script>
const editForm = () => import('./editForm'); // 表单
import { getExamineListApi } from '@/api/user.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    editForm,
  },
  inject: ['reload'],
  mounted() {
    this.getList();
  },
  data() {
    return {
      listLoading: false,
      path: '',
      list: [],
    };
  },
  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  created() {
    // const arr = this.$route.path.split('/');
    // this.path = arr[arr.length - 1];
  },
  watch: {
    paginObj: 'getList',
  },
  methods: {
    // 获取数据的方法
    async getList() {
      this.listLoading = true;
      await getExamineListApi().then((res) => {
        this.listLoading = false;
        this.list = res.data;
      });
    },
    handleExamineBtn(row) {
      this.$refs.editForm.appRecordId = row.appointId;
      this.$refs.editForm.dialogTitle = '审批';
      this.$refs.editForm.dialogFormVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.appPublish {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
